import { Link } from 'react-router-dom';

const NAV_LINKS = [
  { label: 'Home', path: '/' },
  { label: 'Things to Do', path: '/things-to-do' },
  { label: 'Best Luxury Cabins', path: '/best-luxury-cabins' },
  { label: 'Dog-Friendly Guide', path: '/dog-friendly-highlands-nc' },
  { label: 'Cabins Near Glen Falls', path: '/cabins-near-glen-falls-highlands-nc' },
  { label: 'Cabins in Highlands NC', path: '/cabins-in-highlands-nc' },
  { label: 'Vacation Rentals', path: '/vacation-rentals-highlands-nc' },
  { label: 'Places to Stay', path: '/places-to-stay-highlands-nc' },
];

const GUIDE_LINKS = [
  { label: 'Pet Friendly Cabins Highlands NC', href: '/best-luxury-cabins' },
  { label: 'Luxury Vacation Homes', href: '/best-luxury-cabins' },
  { label: 'Where to Stay in Highlands NC', href: '/best-luxury-cabins' },
  { label: 'Dog-Friendly Highlands NC', href: '/dog-friendly-highlands-nc' },
];

export default function Footer() {
  return (
    <footer className="bg-[#1E3530]">
      <div className="max-w-7xl mx-auto px-6 lg:px-14 pt-20 pb-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-14 pb-14 border-b border-white/10">
          <div className="lg:col-span-5">
            <Link to="/" className="inline-block mb-6 cursor-pointer">
              <img
                src="https://public.readdy.ai/ai/img_res/0e161647-590e-4d31-89c6-e540141c5b98.png"
                alt="Highlands NC Luxury Cabins"
                className="h-12 w-auto object-contain brightness-0 invert opacity-90"
              />
            </Link>
            <p className="text-white/60 text-sm leading-relaxed font-jost max-w-xs mb-4">
              Your curated guide to the best cabin stays and local experiences in Highlands, North Carolina.
            </p>
            <p className="text-white/45 text-xs leading-relaxed font-jost max-w-xs">
              Curated guide to cabins in Highlands NC, including pet-friendly cabins and stays near waterfalls.
            </p>
            <p className="text-[#C9A96E] font-cormorant text-xl italic mt-5 leading-snug">
              "Where luxury meets<br/>the mountains."
            </p>
          </div>

          <div className="lg:col-span-3">
            <h4 className="text-white text-xs tracking-[0.2em] uppercase font-jost mb-5">Navigate</h4>
            <ul className="space-y-3">
              {NAV_LINKS.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-white/55 text-sm font-jost hover:text-white/90 transition-colors cursor-pointer"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-4">
            <h4 className="text-white text-xs tracking-[0.2em] uppercase font-jost mb-5">Guides</h4>
            <ul className="space-y-3">
              {GUIDE_LINKS.map((link) => (
                <li key={link.label}>
                  <Link
                    to={link.href}
                    className="text-white/55 text-sm font-jost hover:text-white/90 transition-colors cursor-pointer"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="flex flex-col md:flex-row items-center justify-between gap-4 pt-8">
          <p className="text-white/35 text-xs font-jost">
            &copy; {new Date().getFullYear()} Highlands NC Luxury Cabins. All rights reserved.
          </p>
          <div className="flex items-center gap-5">
            <span className="text-white/35 text-xs font-jost">Highlands, North Carolina 28741</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
